module.exports = __webpack_public_path__ + "img/quiz-guidelines4.73d22e1d.svg";